import { render, staticRenderFns } from "./PhotoAuthEdit.vue?vue&type=template&id=589f0a34"
import script from "./PhotoAuthEdit.vue?vue&type=script&lang=js"
export * from "./PhotoAuthEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports